import {
    ValueComponent,
    ValueComponentDefinition,
} from "components/components/Component";
import { ValueBaseComponent } from "components/components/ValueBaseComponent";
import i18n from "components/i18n/i18n";
import { I18nMessageDefinition } from "components/i18n/I18nMessage";
import marked from "marked";
import template from "./inlineMessage.hbs";
import "./inlineMessage.scss";

export class InlineMessage extends ValueBaseComponent<InlineMessageComponentDefinition> implements ValueComponent {
    public id: string;
    public componentType: "inlineMessage";

    constructor(definition: InlineMessageComponentDefinition) {
        super(definition);
        if (definition.width == null) {
            definition.width = 16;
        }
    }
    public render(): Element {
        let d = document.createElement("div");
        this.view = d as HTMLElement;
        return this.view;
    }

    private static mergeMessage(def: string | string[], args?: object): string {
        let message: string;
        if (Array.isArray(def)) {
            message = def.join("\n");
        } else {
            if (def != null && i18n.instance.exists(def)) {
                message = i18n.instance.t(def, args);
            } else {
                message = def || "";
            }
            if (Array.isArray(message)) {
                message = message.join("\n");
            }
        }
        return message;
    }

    public getValue() {
        return null;
    }

    public value(data: InlineMessageValue): void {
        let message: string;
        let title: string;
        if (data == null) {
            this.view.innerHTML = "";
            return;
        }
        title = i18n.t(data.title);
        message = InlineMessage.mergeMessage(data.body.key);
        this.view.innerHTML = template(Object.assign(
            this.definition,
            {
                html: marked(message),
                title,
                level: data.level,
            }));
    }
}

export interface InlineMessageComponentDefinition extends ValueComponentDefinition {
}

export interface InlineMessageValue extends ValueComponentDefinition {
    level: "error" | "warning" | "info" | "success";
    title?: I18nMessageDefinition;
    body?: I18nMessageDefinition;
}
